<div class="sign-container">
  <!-- Signature Pad-->
  <canvas id="signature-pad" class="sign-container__canvas" [width]="450" [height]="250"></canvas>
  <!-- Tools bar-->
  <div class="tools-bar">
    <button class="tools-bar-button" (click)="setWidthSignPencil(1)">
      <span
        class="tools-bar-button__pencil tools-bar-button__pencil--width8"
        [ngClass]="{ 'tools-bar-button__pencil--enable': currentWithSign === 1 }"
      ></span>
    </button>
    <button class="tools-bar-button" (click)="setWidthSignPencil(2)">
      <span
        class="tools-bar-button__pencil tools-bar-button__pencil--width10"
        [ngClass]="{ 'tools-bar-button__pencil--enable': currentWithSign === 2 }"
      ></span>
    </button>
    <button class="tools-bar-button" (click)="setWidthSignPencil(3)">
      <span
        class="tools-bar-button__pencil tools-bar-button__pencil--width12"
        [ngClass]="{ 'tools-bar-button__pencil--enable': currentWithSign === 3 }"
      ></span>
    </button>
    <button class="tools-bar-button" (click)="setWidthSignPencil(4)">
      <span
        class="tools-bar-button__pencil tools-bar-button__pencil--width14"
        [ngClass]="{ 'tools-bar-button__pencil--enable': currentWithSign === 4 }"
      ></span>
    </button>
    <button class="tools-bar-button" (click)="undoSign()">
      <i class="fa-solid fa-rotate-left tools-bar-button__icon"></i>
    </button>
    <button class="tools-bar-button" (click)="redoSign()">
      <i class="fa-solid fa-rotate-right tools-bar-button__icon"></i>
    </button>
    <button class="tools-bar-button" (click)="clearSign()">
      <i class="fa-solid fa-trash tools-bar-button__icon"></i>
    </button>
  </div>
</div>

<button id="btn1" style="display: none"></button>
